import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import { colors, fontFamily } from '../../theme';
import UserDetailModal from '../book/UserDetailModal';
import AccountTemplateModal from '../shared/AccountTemplateModal';

export default function SubAgentAdminSection({ currentUser, perms }) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showApplyAll, setShowApplyAll] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.getAccounts();
      setAccounts(data.users || []);
    } catch (err) {
      console.error('Failed to load agents:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const agents = accounts.filter(u => u.role === 'agent');

  if (loading) {
    return <p style={{ color: colors.textMuted, fontFamily }}>Loading agents...</p>;
  }

  return (
    <div style={{ color: colors.textPrimary, fontFamily }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2 style={{ color: colors.textPrimary, margin: 0 }}>Agent Admin ({agents.length})</h2>
        {agents.length > 0 && perms?.can_add_agents && (
          <button
            onClick={() => setShowApplyAll(true)}
            style={{ background: colors.goldActiveBg, border: `1px solid ${colors.gold}`, color: colors.textPrimary, borderRadius: 6, padding: '0.4rem 0.9rem', cursor: 'pointer', fontWeight: 700, fontFamily, fontSize: '0.85rem' }}
          >
            Apply to All
          </button>
        )}
      </div>
      <div style={{ display: 'grid', gap: '0.5rem' }}>
        {agents.map(a => (
          <button
            key={a.id}
            onClick={() => setSelected(a)}
            style={{ textAlign: 'left', background: colors.cardBg, boxShadow: colors.shadowCard, border: 'none', borderRadius: 8, padding: '0.75rem 1rem', color: colors.textPrimary, cursor: 'pointer', fontFamily }}
          >
            <span style={{ fontWeight: 600 }}>{a.name}</span>
            <span style={{ color: colors.textMuted, marginLeft: '0.5rem' }}>@{a.username}</span>
            {!a.is_active && (
              <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem', padding: '2px 8px', borderRadius: 20, background: 'rgba(220,53,69,0.2)', color: colors.negative }}>Disabled</span>
            )}
          </button>
        ))}
      </div>

      {selected && (
        <UserDetailModal
          user={selected}
          currentUser={currentUser}
          accounts={accounts}
          onClose={() => setSelected(null)}
          onUpdate={load}
        />
      )}

      {showApplyAll && (
        <AccountTemplateModal
          scope="agent"
          targetLabel="sub-agents"
          targetCount={agents.length}
          perms={perms}
          onClose={() => setShowApplyAll(false)}
          onApplied={load}
        />
      )}
    </div>
  );
}
